<template>
  <div class="panel_wrapper panel_wrapper_26">
    <dv-border-box-12 :color="['#227ead', 'rgb(124, 231, 253)']">
      <div class="pad_6 s_title">
        <div class="title_l">
          设备管理
        </div>
        <div class="title_r" />
      </div>
      <div class="device_manage_wrap">
        <div class="device_manage_quantity">
          <div class="outline_border">
            <p>{{sn}}</p>
            <p>设备编码</p>
          </div>
        </div>
        <div class="device_manage_ratio">  
          <p>当前读数：{{current}}</p>              
          <p>设备状态：{{readstatus}}</p>
          <p>阀门状态：{{valvestatus}}</p>
          <p>设备电池：{{batteryvol}}</p>                    
        </div>
      </div>            
    </dv-border-box-12>
  </div>  
</template>

<script>
export default {
  data () {
    return {
      sn:'无设备',
      current:0,
      batteryvol:0,
      readstatus:'正常',
      valvestatus:'关闭'
    }
  },
  mounted () {
    
  },
  methods: {
    getData() {
      var that = this;
      this.$post("/apis/manage/home/getPlaceMeter", {
        token: sessionStorage.getItem("token"),
        placeid: sessionStorage.getItem("selectPlace")
      })
        .then(function(res) {
          if (res.errno == 0) {
            var data = res.data;
            that.sn = data.sn;
            that.current = data.current;
            that.batteryvol = data.batteryvol;
            that.readstatus = data.readstatus == 1 ? '正常' : '异常';
            that.valvestatus = '关闭';
            if(data.valvestatus == 0){
              that.valvestatus = '开启';
            }else if(data.valvestatus == 0){
              that.valvestatus = '阀门故障';
            }
          }
        })
        .catch(function(err) {
          window.console.log(err);
        });
    },
  }
}
</script>

<style lang="less" scoped>
  .s_title {
    width: 100%;
    height: 48px;
    display: flex;
    .title_l {
      flex: 1;
      width: 130px;
      line-height: 30px;
      border-radius: 2px;
      font-size: 18px;
      text-align: center;
      color: rgb(143, 185, 196); 
      box-shadow: 0px 0px 21px rgb(152, 175, 182) inset;
    }
    .title_r {
      flex: 3;
      display: flex;
    }    
  }
  .device_manage_wrap {
    width: 98%;
    height: calc(100% - 42px);
    margin: 0 auto;       
    display: flex;     
    justify-content: space-around;
    align-items: center; 
    .device_manage_quantity {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;   
      .outline_border {
        width: 50%;
        height: 50%;
        border: 1px solid #2c58a6;
        border-radius: 19px;
        box-shadow: rgba(38, 97, 129, 0.533) 0px 0px 30px inset;
        border-color: rgb(50, 80, 94);          
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        >p {
          padding: 6px 0;
        }
      }         
    }     
    .device_manage_ratio {
      width: 50%;
      height: 68%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }      
  } 
</style>